import wixLocation from 'wix-location';
import wixData from 'wix-data';

$w.onReady(function () {
  //LOAD MORE ------------------------------------------------
  $w("#box1").onViewportEnter((event, $w) => {
	  if($w("#fieldtripsDataset").hasNextPage()){
		  $w('#loadingText').show();
      $w("#fieldtripsDataset").loadMore().then(() => {
	      $w('#loadingText').hide();
      });
	  }
  });
  // LINK TITLE A PAGINA DINAMICA
  $w('#repeater1').onItemReady(($item, itemData, index) => {
    //link title
		$item("#titleText").html = "<a target='_blank' href='http://www.wcsj2019.eu" + itemData["link-Sessions-title"] + "'><h4>" + itemData.title + "</h4></a>"
	});
});